import React from 'react';
// import Link from 'next/link';
const Link = require("react-router-dom").Link

// <ul className="ps-list--social">
//     <li>
//         <a className="facebook" href="#">
//             <i className="fa fa-facebook"></i>
//         </a>
//     </li>
//     <li>
//         <a className="twitter" href="#">
//             <i className="fa fa-twitter"></i>
//         </a>
//     </li>
//     <li>
//         <a className="google-plus" href="#">
//             <i className="fa fa-google-plus"></i>
//         </a>
//     </li>
//     <li>
//         <a className="instagram" href="#">
//             <i className="fa fa-instagram"></i>
//         </a>
//     </li>
// </ul>
const FooterWidgets = () => (
    <div className="ps-footer__widgets">
        <aside className="widget widget_footer widget_contact-us">
            <h4 className="widget-title">Contact Us</h4>
            <div className="widget_content">
                <p>Call us anytime at:</p>
                <h3>1-833-GETZO-33</h3>
                <p>
                    Toronto, Ontario | Canada <br />
                    <a href="mailto:info@getzo.com">info@getzo.com</a>
                </p>

            </div>
        </aside>
        

    </div>
);

export default FooterWidgets;
